<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">CRM Trigger</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="triggerType" class="pb-1">Trigger type</label>
          <input
            id="triggerType"
            type="text"
            v-model="form.triggerType"
            class="form-control"
            disabled="disabled"
          />
        </div>
        <div class="col">
          <label for="frequency" class="pb-1">Frequency</label>
          <input
            id="frequency"
            type="text"
            v-model="form.frequency"
            class="form-control"
            disabled="disabled"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="triggerName" class="pb-1"
            >Trigger name<span class="required">*</span></label
          >
          <input
            id="triggerName"
            type="text"
            v-model="form.triggerName"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorTriggerName,
            }"
          />
          <div v-if="isSubmit && error.errorTriggerName" class="text-error">
            {{ error.errorTriggerName.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="startDate"
            >Start date<span class="required">*</span></label
          >
          <date-picker
            id="startDate"
            v-bind="$attrs"
            v-model="form.startDate"
            format="D MMMM yyyy"
            lang="en"
            :value="form.startDate"
            @change="
              changeStartDate($event);
              form.startDate = $event;
            "
            style="margin-top: -0.6rem"
            :class="{
              'input--error': isSubmit && error.errorStartDate,
            }"
          />
          <div v-if="isSubmit && error.errorStartDate" class="text-error">
            {{ error.errorStartDate.message }}
          </div>
        </div>
        <div class="col">
          <label for="endDate">End date<span class="required">*</span></label>
          <date-picker
            id="endDate"
            v-bind="$attrs"
            v-model="form.endDate"
            format="D MMMM yyyy"
            lang="en"
            :value="form.endDate"
            :minDate="form.startDate"
            @change="form.endDate = $event"
            style="margin-top: -0.6rem"
            :class="{
              'input--error': isSubmit && error.errorEndDate,
            }"
          />
          <div v-if="isSubmit && error.errorEndDate" class="text-error">
            {{ error.errorEndDate.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pb-1">Status</div>
          <div class="d-flex flex-row">
            <input
              class="form-check-input mr-2"
              id="isActive"
              type="checkbox"
              v-model="form.status"
              :class="{
                'input--error': isSubmit && error.errorStatus,
              }"
            />
            <label class="form-check-label" for="isActive"> Active </label>
          </div>
          <div v-if="isSubmit && error.errorStatus" class="text-error">
            {{ error.errorStatus.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <CommonInput
          v-if="isFieldShown('prelapsedPeriod')"
          v-model.number="form.monthPeriod"
          :error="error.errorMonthPeriod"
          :is-submit="isSubmit"
          :label="
            form.triggerType === 'IPSA_PRE_LAPSED'
              ? 'Pre-lapse period (months)'
              : 'Not purchase period (months)'
          "
          identifier="prelapsedPeriod"
        />
        <CommonInput
          v-if="isFieldShown('daysAfterLastPurchase')"
          v-model.number="form.daysAfterLastPurchase"
          :error="error.errorDaysAfterLastPurchase"
          :is-submit="isSubmit"
          label="The number of days after last purchase"
          identifier="daysAfterLastPurchase"
        />
        <CommonInput
          v-if="isFieldShown('daysAfterFirstBill')"
          v-model.number="form.daysAfterFirstBill"
          :error="error.errorDaysAfterFirstBill"
          :is-submit="isSubmit"
          label="The number of days after first bill"
          identifier="daysAfterFirstBill"
        />
      </div>
      <div class="row">
        <CommonInput
          v-if="isFieldShown('afterFirstBillDayPeriod')"
          v-model.number="form.afterFirstBillDayPeriod"
          :error="error.errorAfterFirstBillDayPeriod"
          :is-submit="isSubmit"
          :label="
            form.triggerType === 'NARS_TOUCH_3_AND_4'
              ? 'The number of days after first bill (with and without purchase)'
              : form.triggerType === 'Shiseido TOUCH 1 AND 2'
              ? 'The number of days after last purchase'
              : 'The number of days after first purchase'
          "
          identifier="afterFirstBillDayPeriod"
        />
      </div>
      <FirstBillPurchaseCondition
        v-if="isFieldShown('withOrWithoutPurchase')"
        :error="error"
        :form="form"
        :is-submit="isSubmit"
      />
      <AddSkinCheckupProduct
        v-if="isFieldShown('skinCheckupProduct')"
        :brand-code="form.brandCode"
        :list-skin-checkup-products="listSkinCheckupProducts"
        :error="error"
        :is-submit="isSubmit"
      />
      <ListSkinCheckupProduct
        v-if="listSkinCheckupProducts.length > 0"
        :items="listSkinCheckupProducts"
        @deleteSkinCheckupProduct="deleteSkinCheckupProduct"
      />
      <Top40ProductCondition
        v-if="isFieldShown('top40')"
        :error="error"
        :form="form"
        :is-submit="isSubmit"
      />
      <PurchaseOption
        v-if="isFieldShown('billType')"
        :error="error"
        :form="form"
        :is-submit="isSubmit"
      />
      <PurchaseSfsLxOption
        v-if="isFieldShown('PurchaseSfsLxOption')"
        :error="error"
        :form="form"
        :is-submit="isSubmit"
      />
      <div class="row">
        <CommonInput
          v-if="isFieldShown('monthNotPurchasePeriod')"
          v-model.number="form.monthNotPurchasePeriod"
          :error="error.errorMonthNotPurchasePeriod"
          :is-submit="isSubmit"
          label="Not purchase period (months)"
          identifier="monthNotPurchasePeriod"
        />
        <CommonInput
          v-if="isFieldShown('minTotalPurchase')"
          v-model.number="form.minTotalPurchase"
          :error="error.errorMinTotalPurchase"
          :is-submit="isSubmit"
          label="HV Value segmentation (minimum spending in past 12 months)"
          identifier="minTotalPurchase"
        />
      </div>
      <div class="message-information pt-7">
        <div class="label-title">Message information</div>
        <div class="row">
          <div class="col">
            <div class="pb-1">Message type<span class="required">*</span></div>
            <div class="d-flex flex-row">
              <div class="form-check form-check-inline pr-15" v-show="isTypeLineAllowed()">
                <input
                  class="form-check-input mr-2"
                  id="LINE"
                  type="checkbox"
                  v-model="form.isSentViaLine"
                  @change="changeChkLINE"
                />
                <label class="form-check-label" for="LINE">Line message</label>
              </div>
              <div class="form-check form-check-inline pr-15" v-show="isTypeSmsAllowed()">
                <input
                  class="form-check-input mr-2"
                  id="SMS"
                  type="checkbox"
                  v-model="form.isSentViaSms"
                  @change="changeChkSms"
                />
                <label class="form-check-label" for="SMS">SMS</label>
              </div>
              <div class="form-check form-check-inline" v-show="isTypePushAllowed()">
                <input
                  class="form-check-input mr-2"
                  id="PUSH_NOTI"
                  type="checkbox"
                  v-model="form.isSentViaPushNoti"
                  @change="changeChkPushNoti"
                />
                <label class="form-check-label" for="PUSH_NOTI"
                  >Push notification</label
                >
              </div>
            </div>
            <div v-if="isSubmit && error.errorIsSentViaLine" class="text-error">
              {{ error.errorIsSentViaLine.message }}
            </div>
            <div v-if="isSubmit && error.errorIsSentViaSms" class="text-error">
              {{ error.errorIsSentViaSms.message }}
            </div>
          </div>
        </div>
        <LineMessageTemplate
          v-if="form.isSentViaLine && isFieldShown('messageTemplate')"
          :trigger-type="form.triggerType"
          :has-top40="form.hasTop40Products !== null"
          :message-template="form.messageTemplates"
          :error-message-templates="error.errorMessageTemplateLine"
          :error="error"
          :is-submit="isSubmit"
          data-id="message-tooltip-line"
          identifier="singleTemplate"
        />
        <SmsMessageTemplate
          v-if="form.isSentViaSms && isFieldShown('messageTemplate')"
          :trigger-type="form.triggerType"
          :has-top40="form.hasTop40Products"
          :message-template="form.messageTemplates"
          :error-message-templates="error.errorMessageTemplateSms"
          :is-submit="isSubmit"
          data-id="message-tooltip-sms"
          identifier="singleTemplate"
          :exclude-customer-section="isLeadCustomerTrigger"
        />
        <PushNotificationTemplate
          v-if="form.isSentViaPushNoti && isFieldShown('messageTemplate')"
          :trigger-type="form.triggerType"
          :has-top40="form.hasTop40Products"
          :message-template="form.messageTemplates"
          :error-message-templates="error.errorMessageTemplatePushNoti"
          :error="error"
          :is-submit="isSubmit"
          data-id="message-tooltip-push-noti"
          identifier="singleTemplate"
        />
        <MessageTemplateByShiseidoPrelapsed
          v-if="
            isFieldShown('messageTemplatesForHvAndLv') &&
            (form.isSentViaLine || form.isSentViaSms || form.isSentViaPushNoti)
          "
          :form="form"
          :error="error"
          :is-submit="isSubmit"
        />
        <MessageTemplateByShiseidoProduct
          v-if="
            isFieldShown('minSpendAndMessageTemplateGroup') &&
            (form.isSentViaLine || form.isSentViaSms || form.isSentViaPushNoti)
          "
          :form="form"
          :error="error"
          :is-submit="isSubmit"
        />
        <MessageTemplateByProductCategories
          v-if="
            isFieldShown('messageTemplateByCategories') &&
            (form.isSentViaLine || form.isSentViaSms || form.isSentViaPushNoti)
          "
          :error="error"
          :form="form"
          :is-submit="isSubmit"
        />
        <MessageTemplateByMembership
          v-if="
            isFieldShown('messageTemplateByMembership') &&
            (form.isSentViaLine || form.isSentViaSms || form.isSentViaPushNoti)
          "
          :error="error"
          :form="form"
          :is-submit="isSubmit"
        />
      </div>
      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'CrmTriggers' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel
        </router-link>
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess && id" class="col-12">
            <button class="btn-back" @click="getCrmTriggerDetail">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'CrmTriggers' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ListSkinCheckupProduct from "@/views/CrmTrigger/ListSkinCheckupProduct";
import { CrmTriggerStorageService } from "services/storage.service";
import CrmTriggerService from "services/api/crmTrigger.service";
import MessageTemplateByProductCategories from "@/views/CrmTrigger/MessageTemplateComponent/MessageTemplateByProductCategories.vue";
import Top40ProductCondition from "@/views/CrmTrigger/OptionComponent/Top40ProductCondition.vue";
import FirstBillPurchaseCondition from "@/views/CrmTrigger/OptionComponent/FirstBillPurchaseCondition.vue";
import AddSkinCheckupProduct from "@/views/CrmTrigger/SelectComponent/AddSkinCheckupProduct.vue";
import PurchaseOption from "@/views/CrmTrigger/OptionComponent/PurchaseOption.vue";
import CommonInput from "@/views/CrmTrigger/CommonInput.vue";
import PurchaseSfsLxOption from "@/views/CrmTrigger/OptionComponent/PurchaseSfsLxOption.vue";
import MessageTemplateByShiseidoProduct from "@/views/CrmTrigger/MessageTemplateComponent/MessageTemplateByShiseidoProduct.vue";
import MessageTemplateByShiseidoPrelapsed from "@/views/CrmTrigger/MessageTemplateComponent/MessageTemplateByShiseidoPrelapsed.vue";
import MessageTemplateByMembership from "@/views/CrmTrigger/MessageTemplateComponent/MessageTemplateByMembership.vue";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";
import DatePicker from "components/Datepicker/Datepicker.vue";
import DefaultMessageTemplateData from "components/MessageTemplate/defaultMessageTemplateData";
import ErrorFields from "@/views/CrmTrigger/CommonUtils/errorFields";
import { CrmTriggerFieldLevelError } from "@/views/CrmTrigger/CommonUtils/crmTriggerFieldLevelError";
import {
  shownFieldListForIPSATrigger,
  shownFieldListForNARSTrigger,
  shownFieldListForShiseidoTrigger,
  shownFieldListForCPBTrigger,
  shownFieldListForSFOrEITrigger,
  shownFieldListForDETrigger,
} from "@/views/CrmTrigger/CommonUtils/shownFieldListPerTriggerType";
import {
  getApiFieldListForIPSA,
  getApiFieldListForNARS,
  getApiFieldListForShiseido,
  getApiFieldListForCPB,
  getApiFieldListForSFOrEI,
  getApiFieldListForDE,
} from "@/views/CrmTrigger/CommonUtils/fieldListSentToApiPerTriggerType";

export default {
  components: {
    DatePicker,
    MessageTemplateByShiseidoPrelapsed,
    SmsMessageTemplate,
    LineMessageTemplate,
    PushNotificationTemplate,
    ListSkinCheckupProduct,
    MessageTemplateByProductCategories,
    Top40ProductCondition,
    FirstBillPurchaseCondition,
    AddSkinCheckupProduct,
    PurchaseOption,
    CommonInput,
    PurchaseSfsLxOption,
    MessageTemplateByShiseidoProduct,
    MessageTemplateByMembership,
  },
  data() {
    return {
      id: this.$route.query.id,
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: true,
      isSubmit: false,
      listSkinCheckupProducts: [],
      form: {
        triggerType: null,
        frequency: null,
        brandCode: null,
        triggerName: null,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        status: false,
        isSentViaLine: false,
        isSentViaSms: false,
        isSentViaPushNoti: false,
        messageTemplates: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        monthPeriod: null,
        afterFirstBillDayPeriod: null,
        isWithPurchase: false,
        isWithoutPurchase: false,
        byCategoriesMessageTemplates: [],
        byMembershipMessageTemplates: [],
        hasTop40Products: true,
        top40ProductsTempFilePath: null,
        currentTop40ProductsFilePath: null,
        billType: null,
        monthNotPurchasePeriod: null,
        minTotalPurchase: null,
        messageTemplatesForHv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        messageTemplatesForLv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        daysAfterLastPurchase: null,
        daysAfterFirstBill: null,
        purchaseSfsLx: true,
        minimumSpendingSfsLxHv: null,
        messageTemplatesForSfsLxHv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        minimumSpendingSfsLxLv: null,
        messageTemplatesForSfsLxLv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        minimumSpendingNonSfsLxHv: null,
        messageTemplatesForNonSfsLxHv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        minimumSpendingNonSfsLxLv: null,
        messageTemplatesForNonSfsLxLv: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
        messageTemplatesForAnyPurchase: {
          ...DefaultMessageTemplateData,
          showPeriodInDays: null,
        },
      },
      error: {
        ...ErrorFields,
      },
    };
  },
  mounted() {
    if (this.id) {
      this.getCrmTriggerDetail();
    } else {
      this.getTriggerType();
    }
  },
  computed: {
    isLeadCustomerTrigger() {
      const type = this.form.triggerType || "";
      return (
          type.includes("LEAD CUSTOMERS") ||
          type.includes("_LEAD_CUSTOMERS")
      );
    },
  },
  methods: {
    async getTriggerType() {
      const createTriggerType =
        JSON.parse(CrmTriggerStorageService.getCreateTriggerType()) || {};
      this.form.triggerType = createTriggerType?.text;
      this.form.brandCode = createTriggerType?.brandCode;
      this.isLoading = false;
    },
    async getCrmTriggerDetail() {
      this.showDialog = false;
      this.isSubmit = false;
      await CrmTriggerService.getDetailCrmTrigger(this.id)
        .then((res) => {
          const data = res.data.crmTrigger;
          const form = this.form;
          form.brandCode = data.brandCode;
          this.isLoading = false;
          form.triggerType = data.triggerType;
          form.triggerName = data.triggerName;
          form.startDate = data.startDate;
          form.endDate = data.endDate;
          form.status = data.status === "ACTIVE";
          form.isSentViaLine = data.isSentViaLine;
          form.isSentViaSms = data.isSentViaSms;
          form.isSentViaPushNoti = data.isSentViaPushNoti;
          form.messageTemplates = this.getMessageTemplates(
            data.messageTemplates
          );
          form.monthPeriod = data.monthPeriod;
          form.afterFirstBillDayPeriod = data.afterFirstBillDayPeriod;
          form.isWithoutPurchase = data.isWithoutPurchase;
          form.isWithPurchase = data.isWithPurchase;
          form.byCategoriesMessageTemplates =
            data.byCategoriesMessageTemplates || [];
          form.byMembershipMessageTemplates =
            data.byMembershipMessageTemplates || [];
          form.hasTop40Products = data.hasTop40Products;
          form.currentTop40ProductsFilePath = data.currentTop40ProductsFilePath;
          form.billType = data.billType;
          form.monthNotPurchasePeriod = data.monthNotPurchasePeriod;
          form.minTotalPurchase = data.minTotalPurchase;
          form.messageTemplatesForHv = this.getMessageTemplates(
            data.messageTemplatesForHv
          );
          form.messageTemplatesForLv = this.getMessageTemplates(
            data.messageTemplatesForLv
          );
          form.daysAfterLastPurchase = data.daysAfterLastPurchase;
          form.daysAfterFirstBill = data.daysAfterFirstBill;
          form.purchaseSfsLx = data.purchaseSfsLx;
          form.minimumSpendingSfsLxHv = data.minimumSpendingSfsLxHv;
          form.messageTemplatesForSfsLxHv = this.getMessageTemplates(
            data.messageTemplatesForSfsLxHv
          );
          form.minimumSpendingSfsLxLv = data.minimumSpendingSfsLxLv;
          form.messageTemplatesForSfsLxLv = this.getMessageTemplates(
            data.messageTemplatesForSfsLxLv
          );
          form.minimumSpendingNonSfsLxHv = data.minimumSpendingNonSfsLxHv;
          form.messageTemplatesForNonSfsLxHv = this.getMessageTemplates(
            data.messageTemplatesForNonSfsLxHv
          );
          form.minimumSpendingNonSfsLxLv = data.minimumSpendingNonSfsLxLv;
          form.messageTemplatesForNonSfsLxLv = this.getMessageTemplates(
            data.messageTemplatesForNonSfsLxLv
          );
          form.messageTemplatesForAnyPurchase = this.getMessageTemplates(
            data.messageTemplatesForAnyPurchase
          );
          if (
            form.triggerType === "IPSA_SKIN_CHECKUP" ||
            form.triggerType === "IPSA_PROSPECT"
          ) {
            this.listSkinCheckupProducts = data.productParentCodes.map((p) => {
              return {
                ...p,
                productCode: p,
                isDelete: true,
              };
            });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    getMessageTemplates(messageTemplates) {
      return {
        ...messageTemplates,
        showInInbox: messageTemplates?.showInInbox
          ? messageTemplates.showInInbox
          : false,
      };
    },
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      const form = this.form;
      const body = {
        triggerName: form.triggerName,
        status: form.status ? "ACTIVE" : "INACTIVE",
        brandCode: form.brandCode,
        startDate: moment(form.startDate).format("DD/MM/YYYY"),
        endDate: moment(form.endDate).format("DD/MM/YYYY"),
        isSentViaLine: form.isSentViaLine,
        isSentViaSms: form.isSentViaSms,
        isSentViaPushNoti: form.isSentViaPushNoti,
        triggerType: form.triggerType,
      };
      const fieldList = this.getFieldListSentToApi(body);
      if (this.id) {
        this.updateCrmTrigger(fieldList);
      } else {
        this.addCrmTrigger(fieldList);
      }
    },
    getFieldListSentToApi(body) {
      if (this.form.brandCode === "IP") {
        return getApiFieldListForIPSA(
          body,
          this.form,
          this.listSkinCheckupProducts
        );
      } else if (this.form.brandCode === "NR") {
        return getApiFieldListForNARS(body, this.form);
      } else if (this.form.brandCode === "SH") {
        return getApiFieldListForShiseido(body, this.form);
      } else if (this.form.brandCode === "CP") {
        return getApiFieldListForCPB(body, this.form);
      } else if (this.form.brandCode === "EI") {
        return getApiFieldListForSFOrEI(body, this.form);
      } else if (this.form.brandCode === "DE") {
        return getApiFieldListForDE(body, this.form);
      } else if (this.form.brandCode === "SF") {
        return getApiFieldListForSFOrEI(body, this.form);
      }
    },
    async addCrmTrigger(body) {
      await CrmTriggerService.createCrmTrigger(body)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    async updateCrmTrigger(body) {
      await CrmTriggerService.updateCrmTrigger(body, this.id)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    createOrUpdateSuccess(res) {
      this.isLoading = false;
      const data = res.data;
      this.showDialog = true;
      this.showSuccess = true;
      this.message = data.message ? data.message : "Save CRM Trigger success";
      this.resetErrorText();
    },
    createOrUpdateFailure(err) {
      this.isLoading = false;
      this.resetErrorText();
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        CrmTriggerFieldLevelError(
          this.error,
          errorData.errors,
          this.form.triggerType
        );
        return;
      }
      if (errorData.message) {
        this.showDialog = true;
        this.message = errorData.message;
      }
    },
    deleteSkinCheckupProduct(index) {
      this.listSkinCheckupProducts.forEach((_, i) => {
        if (i === index) {
          this.listSkinCheckupProducts.splice(index, 1);
        }
      });
    },
    getShownFieldListPerBrand(triggerType) {
      if (this.form.brandCode === "IP") {
        return shownFieldListForIPSATrigger(triggerType, this.form);
      } else if (this.form.brandCode === "NR") {
        return shownFieldListForNARSTrigger(triggerType, this.form);
      } else if (this.form.brandCode === "SH") {
        return shownFieldListForShiseidoTrigger(triggerType, this.form);
      } else if (this.form.brandCode === "CP") {
        return shownFieldListForCPBTrigger(triggerType, this.form);
      } else if (this.form.brandCode === "EI") {
        return shownFieldListForSFOrEITrigger(triggerType, this.form);
      } else if (this.form.brandCode === "DE") {
        return shownFieldListForDETrigger(triggerType, this.form);
      } else if (this.form.brandCode === "SF") {
        return shownFieldListForSFOrEITrigger(triggerType, this.form);
      }
    },
    isFieldShown(fieldName) {
      const array = this.getShownFieldListPerBrand(this.form.triggerType);
      if (array?.includes(fieldName)) {
        return true;
      }
    },
    isTypeSmsAllowed() {
      return !this.isTypeNotAllowed("sms");
    },
    isTypeLineAllowed() {
      return !this.isTypeNotAllowed("line");
    },
    isTypePushAllowed() {
      return !this.isTypeNotAllowed("push");
    },
    isTypeNotAllowed(type) {
      return this.getShownFieldListPerBrand(this.form.triggerType)?.includes(type + "MessageTemplateNotAllowed");
    },
    resetErrorText() {
      this.error = {
        ...ErrorFields,
      };
    },
    changeStartDate(val) {
      if (val > this.form.endDate) {
        this.form.endDate = null;
      }
    },
    unCheckChkLineCondition(templates) {
      if (!this.form.isSentViaLine && templates) {
        templates.messageTemplateLine = null;
        templates.imageRelativePath = null;
        templates.imageRelativePathUrl = null;
        templates.targetUrl = null;
        templates.previewImageRelativePath = null;
        templates.previewImageRelativePathUrl = null;
        templates.videoRelativePath = null;
        templates.videoRelativePathUrl = null;
      }
    },
    changeChkLINE() {
      this.unCheckChkLineCondition(this.form.messageTemplates);
      this.unCheckChkLineCondition(this.form.messageTemplatesForHv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForLv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForSfsLxHv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForSfsLxLv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForNonSfsLxHv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForNonSfsLxLv);
      this.unCheckChkLineCondition(this.form.messageTemplatesForAnyPurchase);
      this.form.byCategoriesMessageTemplates.forEach((template) =>
        this.unCheckChkLineCondition(template.messageTemplates)
      );
      this.form.byMembershipMessageTemplates.forEach((template) =>
        this.unCheckChkLineCondition(template.messageTemplates)
      );
    },
    unCheckChkSmsCondition(templates) {
      if (!this.form.isSentViaSms && templates) {
        templates.messageTemplateSms = null;
      }
    },
    changeChkSms() {
      this.unCheckChkSmsCondition(this.form.messageTemplates);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForHv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForLv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForSfsLxHv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForSfsLxLv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForNonSfsLxHv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForNonSfsLxLv);
      this.unCheckChkSmsCondition(this.form.messageTemplatesForAnyPurchase);
      this.form.byCategoriesMessageTemplates.forEach((template) =>
        this.unCheckChkSmsCondition(template.messageTemplates)
      );
      this.form.byMembershipMessageTemplates.forEach((template) =>
        this.unCheckChkSmsCondition(template.messageTemplates)
      );
    },
    unCheckChkPushNotiCondition(templates) {
      if (!this.form.isSentViaPushNoti && templates) {
        templates.messageTemplatePushNoti = null;
        templates.pushNotiTargetUrl = null;
        templates.showInInbox = false;
        templates.showPeriodInDays = null;
      }
    },
    changeChkPushNoti() {
      this.unCheckChkPushNotiCondition(this.form.messageTemplates);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForHv);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForLv);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForSfsLxHv);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForSfsLxLv);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForNonSfsLxHv);
      this.unCheckChkPushNotiCondition(this.form.messageTemplatesForNonSfsLxLv);
      this.unCheckChkPushNotiCondition(
        this.form.messageTemplatesForAnyPurchase
      );
      this.form.byCategoriesMessageTemplates.forEach((template) =>
        this.unCheckChkPushNotiCondition(template.messageTemplates)
      );
      this.form.byMembershipMessageTemplates.forEach((template) =>
        this.unCheckChkPushNotiCondition(template.messageTemplates)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.btn {
  margin: 3rem 0;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}

.content-dialog {
  height: 300px;
  background: #fff;
  overflow-x: hidden;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
